import React from 'react';

class SafeSelectorOption extends React.Component {
	handleChange(e) {
		this.props.onChange(e);
		global.dataLayer.push({
			event: 'Product Selector',
			eventCategory: 'Product Selector',
			eventAction: this.props.trackEventAction,
			eventLabel: this.props.trackEventLabel
		});
	}

	render() {
		const { props } = this;
		return (
			<div className={ `safe-selector-option ${props.className ? props.className : ''}` }>
				<input
					type={ props.type ? props.type : 'radio' }
					id={ props.id }
					name={ props.name }
					value={ props.value }
					checked={ props.checked }
					onChange={ e => this.handleChange(e) }
					onClick={ props.onClick }
					data-index={ props.index }
				/>
				<label htmlFor={ props.id }>
					{ props.label }
				</label>
			</div>
		);
	}
}

export default SafeSelectorOption;


// WEBPACK FOOTER //
// ./src/pages/safeSelector/common/SafeSelectorOption.js